import { z } from 'zod';

export const listSearchSchema = z.object({
  q: z.string().optional(),
});

export type SearchableValue = string | null | undefined;

export function filterRowsBySearch<TRow>(
  rows: TRow[] | undefined,
  appliedText: string | undefined,
  toSearchableValues: (row: TRow) => SearchableValue[],
): TRow[] {
  const allRows = rows ?? [];
  const needle = appliedText?.trim().toLowerCase();
  if (!needle) return allRows;
  return allRows.filter((row) =>
    toSearchableValues(row).filter(Boolean).join(' ').toLowerCase().includes(needle),
  );
}
